import lego from './clients/lego';

export default {
  lego,
};
